export default "__VITE_ASSET__DlWl5WW4__"